// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"6d57807f","473":"21954fbb","613":"dd2db5ef","677":"47121188","925":"56b8ac6b"}[chunkId] + ".chunk.js";
};